export function emptyManualCard(serialNumber) {
  return {
    serial: serialNumber,
    source: "manual",
    select: true,
    nome: "",
    raridade: "",
    edition: "",
    ano: "",
    idioma: "",
    num: "",
    notaGeral: "",
    notaSurface: "",
    notaEdge: "",
    notaCenter: "",
    notaCorner: "",
    invertida: false,
  };
}
